export default __webpack_public_path__ + "static/media/generator.dc1b5f52.png";